import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageBannerCard from '@shared/components/core/card/PageBannerCard';
import PageHeader from '@shared/components/core/headers/PageHeader';
import OrgBillingRedirectContent from '@shared/components/organization/billing/OrgBillingRedirectContent';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useCurrentOrgNavigation } from '@shared/hooks/useCurrentOrgNavigation';
import { useTranslation } from 'react-i18next';

export default function OrgBillingRedirectPage() {
    useCurrentOrgNavigation();
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { canViewOrgDetails } = useCurrentOrgDetailsFetching();

    return (
        <>
            <PageHeader title={t('common:billing.title')} items={canViewOrgDetails ? items : []}></PageHeader>
            <PageBannerCard
                title={t('common:license.redirect.title')}
                description={t('common:license.redirect.description')}
                icon="money"
                fullHeight>
                <OrgBillingRedirectContent />
            </PageBannerCard>
        </>
    );
}
